export default function Font_Characteristics() {
  return (
    <div className="p-4">
      <h1>Font Characteristics</h1>
    </div>
  );
}
